<template>
  <div class="profile-dropdown-container">
    <div class="menu-items" v-on-clickaway="hideDropdown">
      <router-link :to="`/user/${userName}`"
        @click.native="hideDropdown">
        Profile
      </router-link>
      <router-link to="/my-events" @click.native="hideDropdown">
        Event Dashboard
      </router-link>
      <router-link to="/account/edit" @click.native="hideDropdown">
        Account Settings
      </router-link>
      <router-link to="/" @click.native="() => logout() && hideDropdown()">
        Logout
      </router-link>
    </div>
  </div>
</template>

<script>
import { mapActions, mapState } from 'vuex';
import { mixin as clickaway } from 'vue-clickaway';

export default {
  name: 'ProfileDropdown',
  mixins: [clickaway],
  computed: {
    ...mapState('user', ['userName']),
  },
  methods: {
    ...mapActions('auth', ['logout']),
    hideDropdown() {
      this.$emit('hideDropdown');
    },
  },
};

</script>

<style lang="scss" scoped>
@import '@/assets/youpaired-colors.scss';

.profile-dropdown-container {
  position: fixed;
  right: 1.5rem;
  top: 4rem;
  background-color: white;
  cursor: pointer;
  width: 9rem;
  box-shadow: 0 0.5rem 1rem rgba(0, 0, 0, 0.3);
  -webkit-box-shadow: 0 0.5rem 1rem rgba(0, 0, 0, 0.3);
  z-index: 25;
}

.profile-dropdown-container :after {
    content:"";
    position: absolute;
    right: 3px;
    top: -0.5rem;
    border-style: solid;
    border-width: 0 0.55rem 0.55rem 0.55rem;
    border-color: transparent transparent #e8e9ef transparent;
    margin-bottom: 0.1rem;
}

.menu-items {
  display: flex;
  flex-direction: column;
  border-radius: 0.25rem;
  text-align: left;
}

.menu-items > a {
  height: 2rem;
  line-height: 2rem;
  padding: 0rem 1rem 0rem 0.5rem;
  &:hover {
    background-color: #f8f9fb;
  }
  font-size: 0.875rem;
  text-decoration: none;
  color: black;
}


.logout {
  border-top: 0.05rem solid #e2e2e2;
}

</style>
